import styled from '@emotion/styled';

export const PageWithTableWrapper = styled.div`
  margin-right: 1.5rem;
`;
